import fieldInputBackup from './fieldInputBackupMainInclude.js'
import registerHsConfirm from './heftSchliessenConfirm.js'


registerHsConfirm();
fieldInputBackup.cleanOld();

const path = document.location.pathname;

if (path.includes('/Einsendung')) {
    const aufgKey = fieldInputBackup.normalizeUrlPathToAufgKey(path);
    fieldInputBackup.cleanQuittiert(aufgKey);
    fieldInputBackup.cleanIfSubmitForbidden(aufgKey);
}

const addedMarker = fieldInputBackup.addMarkerToLinks();

//Zu diesem If: Siehe Kommentar in fieldInputBackupAufg.js
if (addedMarker)
    fieldInputBackup.addHsConfirmations(fieldInputBackup.normalizeUrlPathKursKey(path));

const fibhelp = document.getElementById("fibhelp");
if (fibhelp !== null) {
    if (!addedMarker) {
        fibhelp.style.display = "none";
    } else {
        fibhelp.style.display = fibhelp.nodeName === "LI" ? "list-item" : "block";
    }
}